import useIsInappWebview from "./useIsInappWebview";
import useGetDeviceInfo from "./useGetDeviceInfo";
import { compareVersions } from "../logic/logics_common";
import useRole from "./useRole";

export default function useIsRecordSeparatedPage() {
  const isInappWebview = useIsInappWebview();
  const { appVersion } = useGetDeviceInfo();
  const isPatient = useRole();

  return (
    (isPatient &&
      isInappWebview &&
      compareVersions(appVersion, "1.1.27") >= 0) ||
    false
  );

  // return false
}
